import { queryOptions } from "@tanstack/react-query";

import { fetchVenueOnlineConfig } from "./requests";

export const VenueOnlineConfigQueries = {
  current: () =>
    queryOptions({
      queryKey: ["venueOnlineConfig"],
      queryFn: fetchVenueOnlineConfig,
    }),
};

export default VenueOnlineConfigQueries;
